import CryptoJS from 'crypto-js';

const regenerateClientApiSecret = () => {
  const secretInput = $('#view_client_secret');
  if (!secretInput[0]) return;

  const secret = CryptoJS.SHA256(`${Date.now()}`);

  secretInput
    .attr('type', 'text')
    .val(secret.toString(CryptoJS.enc.Hex))
    .off('.secret')
    .on('click.secret', e => {
      $(e.target).select();
    });

  if (typeof window.viewFieldChanged === 'function') {
    window.viewFieldChanged('view');
  }
};

$(document).on('click', '.js-system-api-client-regenerate', () => {
  regenerateClientApiSecret();
});
